import angular from "angular";
import controller from "./instructor-documents-index.controller";
import template from "./instructor-documents-index.html";

function config($stateProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.documents.index", {
    url: "",
    controller: controller,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}

config.$inject = ["$stateProvider", "USER_ROLES"];

export default angular
  .module("instructor.documents.index", [])
  .config(config)
  .controller("InstructorDocumentsIndexController", controller);
